import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { api, errMsg } from "@/lib/api";
import { ROLE_LABEL } from "@/lib/format";

const ROLES = ["manajemen", "operasional", "viewer"];

export const MenuAccessCard = () => {
  const [menus, setMenus] = useState([]);
  const [roles, setRoles] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/settings/menu-access").then((r) => { setMenus(r.data.menus); setRoles(r.data.roles); });
  }, []);
  if (!roles) return null;

  const toggle = (role, key) => setRoles({ ...roles, [role]: roles[role].includes(key) ? roles[role].filter((k) => k !== key) : [...roles[role], key] });
  const save = async () => {
    setBusy(true);
    try { setRoles((await api.put("/settings/menu-access", { roles })).data.roles); toast.success("Akses menu disimpan. Berlaku saat pengguna memuat ulang halaman."); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div data-testid="menu-access-card" className="rounded-xl border bg-card p-5 shadow-sm">
      <h3 className="font-heading text-lg font-semibold">Akses Menu per Peran</h3>
      <p className="text-sm text-muted-foreground">Centang menu yang boleh dibuka tiap peran. Admin selalu mendapat semua menu; Ringkasan selalu tampil. Sinkronisasi, Pengguna & Pengaturan khusus Admin.</p>
      <div className="mt-4 overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs uppercase tracking-wider text-muted-foreground">
            <th className="py-2 pr-4">Menu</th>{ROLES.map((r) => <th key={r} className="px-3 text-center">{ROLE_LABEL[r]}</th>)}
          </tr></thead>
          <tbody>
            {menus.map((m) => (
              <tr key={m.key} className="border-t">
                <td className="py-2 pr-4 font-medium">{m.label}</td>
                {ROLES.map((r) => (
                  <td key={r} className="px-3 text-center">
                    <Checkbox data-testid={`menu-access-${r}-${m.key}`} checked={roles[r].includes(m.key)} onCheckedChange={() => toggle(r, m.key)} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Button data-testid="menu-access-save-button" className="mt-4" onClick={save} disabled={busy}>
        {busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Save className="mr-1.5 h-4 w-4" />}Simpan Akses Menu
      </Button>
    </div>
  );
};
